import React, { useContext, useEffect, useState } from 'react';
import { UserOrderContext } from 'context/context';
import { translateWithI18Next } from '@kfc-global/kfc-i18n/lib';
import { checkAllTrue, getAndCheck, getAndCheckIfOneTrue } from 'common/utilities/utils';
import PdpSummaryUpsizeComponent from 'atoms/PdpSummary/AU/Presentation/PdpSummaryUpsizeComponent';
import NutitionAllergenComponent from 'organisms/NutritionAllergen/Container/NutritionAllergenComponent';
import { IMAGE_PATH } from 'common/ImageConstants/ImagePathUtils';
import ImageComponent from 'atoms/Image';
import { AnchorWithLink } from 'atoms/Anchor';
import { MENU_PDP_PAGE_CONSTANTS } from 'organisms/MenuPDPPage/AU/Constants/MenuPDPPageConstants';
import {
  getAddToCartTemplate,
  computeSurgePrice,
  checkExcludedItem,
} from 'organisms/MenuPDPPage/AU/Utilities/MenuPDPUtils';
import { LOCAL_STORAGE_KEYS } from 'common/constants/SharedConstants';
import { TRANSLATE_MAPPING_KEY } from 'common/constants/i18nTranslateKeys';
import { ReactSVG } from 'react-svg';
import { useSelector } from 'react-redux';

export const getSurgePriceValue = (availability, getTimeZoneValue) => {
  return availability && getTimeZoneValue && computeSurgePrice(availability, getTimeZoneValue);
};
/**
 * PDP summary Component
 */
export const PdpSummaryCardComponent = props => {
  const {
    cardId,
    calories,
    customizable,
    price,
    upsizeInfo,
    upSizeHandler,
    showAddToCartButton,
    availability,
    isStoreClosed,
    kilojoule,
    pdpCardObject,
    pdpPromoPage,
    storeTimeZone,
    modgrps,
    servesCount,
  } = props;

  const tenantData = useSelector(data => data.tenantReducer);
  const { storesWithStatus } = useSelector(data => data.storesReducer);
  const storeTimeZoneIANA = storesWithStatus[0]?.summary?.timeZoneIANA;
  const hideAllergyNutrition = tenantData?.componentOptions?.web?.pdp?.showAllergyNutrition;

  const { userParams } = pdpCardObject;
  const [surgePriceObj, setSurgePriceObj] = useState({});
  const { nutritionAllergenHandler, showNutritionAllergenModal } = props?.nutritionDetails || {};
  const { ALLERGY_NUTRITION_TEXT, PDP_CHOOSE_STORE, MODGROUPMAX, SELECTED_ITEM_NOT_AVAILABLE } =
    MENU_PDP_PAGE_CONSTANTS;
  const summaryData = props;
  const { userOrderState } = useContext(UserOrderContext);
  const { pdpPayloadData } = userOrderState;
  pdpCardObject[MODGROUPMAX] = modgrps?.[0]?.max;
  pdpCardObject[SELECTED_ITEM_NOT_AVAILABLE] = getAndCheckIfOneTrue(
    summaryData?.isExcluded,
    checkExcludedItem(pdpPayloadData),
  );
  pdpCardObject.itemId = cardId;

  useEffect(() => {
    setSurgePriceObj(getSurgePriceValue(availability, storeTimeZoneIANA));
  }, [availability, storeTimeZoneIANA]);

  const getChooseAStoreView = () => {
    return (
      <div className='pdp-summary-cart-notification'>
        <div className='notify-alert'>
          <ImageComponent srcFile={IMAGE_PATH.Error_Yellow} className='location-alert-icon' />
          <span>{translateWithI18Next(PDP_CHOOSE_STORE)}</span>
        </div>
      </div>
    );
  };

  const getPromosTagAndPrice = (itemId, menuAvailability) => {
    const promoDetails = JSON.parse(localStorage.getItem(LOCAL_STORAGE_KEYS.VIEW_PRODUCT));
    const promoAvailability = [
      computeSurgePrice(promoDetails?.priceDetails?.find(it => it?.id === itemId)?.availability, storeTimeZoneIANA),
    ];
    const promoPrice =
      promoAvailability?.[0]?.promoPrice < promoAvailability?.[0]?.price ? promoAvailability?.[0]?.promoPrice : 0;
    const menuWithPromoAvailability = promoPrice
      ? {
          ...promoAvailability?.[0],
          price: promoPrice,
        }
      : menuAvailability;

    if (promoPrice && pdpPromoPage) {
      return (
        <>
          <div data-testid='pdp-promos-with-price' className='pdp-promos-container with-price'>
            <ReactSVG src={IMAGE_PATH.Promos_Coupon_Icon} alt='promo-tag' className='pdp-promo-img' />
            <span className='pdp-promo-text'>{translateWithI18Next(TRANSLATE_MAPPING_KEY.PROMO_TEXT)}</span>
            <span className='pdp-promo-text'>
              <del>{price(customizable, promoAvailability?.[0], false, storeTimeZone)}</del>
            </span>
          </div>
          <span className='price-info'>{price(customizable, menuWithPromoAvailability, false, storeTimeZone)}</span>
        </>
      );
    } else if (pdpPromoPage) {
      return (
        <>
          <span data-testid='pdp-promos' className='pdp-promos-container'>
            <ReactSVG src={IMAGE_PATH.Promos_Coupon_Icon} alt='promo-tag' className='pdp-promo-img-price' />
            <span className='pdp-promo-text-price'>{translateWithI18Next(TRANSLATE_MAPPING_KEY.PROMO_TEXT)}</span>
          </span>
          <span className='price-info-price'>{price(customizable, menuAvailability, false, storeTimeZone)}</span>
        </>
      );
    }
    return <span className='price-info'>{price(customizable, menuAvailability, false, storeTimeZone)}</span>;
  };

  const getPriceKJView = () => {
    return (
      <div className='price-kj-info'>
        {getPromosTagAndPrice(cardId, surgePriceObj)}
        <span className='kj-css'>
          {calories && (
            <span className='kj-info'>
              {`${calories} ${kilojoule}`} &nbsp;{' '}
              {`${translateWithI18Next(TRANSLATE_MAPPING_KEY?.SERVES)} ${servesCount} `}
            </span>
          )}
        </span>
      </div>
    );
  };

  const nutritionView = (
    <div className='allergy-info'>
      <AnchorWithLink
        onClickHandler={nutritionAllergenHandler}
        className='allergy-info-link'
        data-testid='allergy-info'
      >
        {translateWithI18Next(ALLERGY_NUTRITION_TEXT)}
      </AnchorWithLink>
    </div>
  );
  const comboUpsizeView = checkAllTrue([userParams?.localized, !isStoreClosed, upsizeInfo.length > 0]) ? (
    <PdpSummaryUpsizeComponent
      upsizeInfo={upsizeInfo}
      upSizeHandler={upSizeHandler}
      itemSelected={cardId}
      customizable={customizable}
    />
  ) : null; //render only for combo & localized & product has more than one item
  const chooseAStoreView = getAndCheckIfOneTrue(!userParams?.localized, isStoreClosed) && getChooseAStoreView(); // render choose a store div for non-localized
  const pricekjView = getAndCheck(userParams?.localized, !isStoreClosed) && getPriceKJView(); //render KJ ,price div only for localized
  const addToCartTemplate =
    checkAllTrue([showAddToCartButton, userParams?.localized, !isStoreClosed]) && getAddToCartTemplate(pdpCardObject);

  const nutritionAllergenModalComponent = (
    <NutitionAllergenComponent isMobile={pdpCardObject.isMobile} summaryData={summaryData} />
  );

  return (
    <>
      {pricekjView}
      {hideAllergyNutrition && nutritionView}
      {comboUpsizeView}
      {chooseAStoreView}
      {addToCartTemplate}
      {showNutritionAllergenModal && nutritionAllergenModalComponent}
    </>
  );
};
